import { useFormContext, Controller } from "react-hook-form";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    CircularProgress,
    MenuItem
} from "@mui/material";

interface PropsEditarPrescricao {
    open: boolean;
    onClose: () => void;
    isEditing: boolean;
    handleFormSubmit: (data: any) => void;
}

const unidadeDoseOptions = [
    { value: "GRA", label: "Gramas (GRA)" },
    { value: "HA", label: "Hectares (HA)" },
    { value: "KG", label: "Quilogramas (KG)" },
    { value: "L", label: "Litros (L)" },
    { value: "LT", label: "Litros (LT)" },
    { value: "ML", label: "Mililitros (ML)" },
    { value: "UN", label: "Unidades (UN)" },
];

const unidadeAreaOptions = [
    { value: "HA", label: "Hectares (HA)" },
    { value: "KG", label: "Quilogramas (KG)" },
    { value: "KGS", label: "Quilogramas (KGS)" },
    { value: "L", label: "Litros (L)" },
    { value: "LA", label: "Litros (LA)" },
    { value: "LT", label: "Litros (LT)" },
    { value: "mt2", label: "Metros quadrados (m²)" },
    { value: "mt3", label: "Metros cúbicos (m³)" },
    { value: "PL", label: "PL" },
    { value: "T", label: "Toneladas (T)" },
    { value: "UN", label: "Unidades (UN)" },
];

export default function DialogEditarDosagemAplicacao({
                                                        open,
                                                        onClose,
                                                        isEditing,
                                                        handleFormSubmit
                                                    }: PropsEditarPrescricao) {
    const {handleSubmit, control} = useFormContext();

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle>Editar Dosagem e aplicação</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mt={1}>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="quantidade_dose"
                            control={control}
                            rules={{ required: "Quantidade da dose é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Quantidade da dose"
                                    type="number"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="unidade_dose"
                            control={control}
                            rules={{ required: "Unidade da dose é obrigatória" }}
                            render={({ field, fieldState:{error, invalid} }) => (
                                <TextField
                                    {...field}
                                    select
                                    label="Unidade dose"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                >
                                    {unidadeDoseOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="tamanho_area"
                            control={control}
                            rules={{ required: "Tamanho da área é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Tamanho da área"
                                    type="number"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="unidade_area"
                            control={control}
                            rules={{ required: "Unidade da área é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Unidade da área"
                                    type="string"
                                    select
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                >
                                    {unidadeAreaOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 4}}>
                        <Controller
                            name="quantidade_aplicacoes"
                            control={control}
                            rules={{ required: "Quantidade de aplicações é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Quantidade de aplicações"
                                    type="number"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 4}}>
                        <Controller
                            name="dias_intervalo_aplicacoes"
                            control={control}
                            rules={{ required: "Dias de intervalo entre aplicações é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Dias de intervalo entre aplicações"
                                    type="number"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 4}}>
                        <Controller
                            name="dias_carencia"
                            control={control}
                            rules={{ required: "Dias de carência é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Dias de carência"
                                    type="number"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose} disabled={isEditing}>
                    Cancelar
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isEditing}
                    onClick={handleSubmit(handleFormSubmit)}
                    startIcon={isEditing ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {isEditing ? "Editar..." : "Editar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}